import { render, staticRenderFns } from "./ImportHistoryModal.vue?vue&type=template&id=2774357e"
import script from "./ImportHistoryModal.vue?vue&type=script&lang=ts"
export * from "./ImportHistoryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports